import './new-employment-type.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateEmploymentType } from "@core/query/employment-type.query";
import { EmploymentTypeFormRule, EmploymentTypeFormSchema } from "@core/form/form.rule";
import { employmentTypeFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormEmploymentType from "../form-employment-type/form-employment-type";

export function EmploymentType() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateEmploymentType } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New EmploymentType is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addEmploymentType, isLoading: isCreating } =
    useQyCreateEmploymentType(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<EmploymentTypeFormSchema>({
    defaultValues: employmentTypeFormDefault,
    resolver: zodResolver(EmploymentTypeFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: EmploymentTypeFormSchema) => {
    const formData = mapCreateEmploymentType(form);
    addEmploymentType(formData);
  };
  const handleValidateError = (err: FieldErrors<EmploymentTypeFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="EmploymentType" className="employment-type">
      <HeaderContent
        title="New EmploymentType"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormEmploymentType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default EmploymentType;